import LabelerContainer from "./container";

export default LabelerContainer;
